// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import ResponsiveImage from '../../internal/ResponsiveImage';

const blockVariantMap = {
  Low: 'Featured',
  Medium: 'Default',
  High: 'DefaultContrast',
  Dark: 'Dark',
};

type PropTypes = {|
  title: string,
  logos: Array<{|
    image: string,
    name: string,
  |}>,
  background: 'Dark' | 'Medium' | 'Low' | 'High',
|};

const Logos = (props: PropTypes) => {
  return (
    <PageContentBlock background={blockVariantMap[props.background]}>
      <h2 className={styles.title}>{props.title}</h2>
      <ul className={styles.logoList}>
        {props.logos.map((logo, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index}>
            <ResponsiveImage
              className={styles.logo}
              src={logo.image}
              alt={logo.name}
              defaultSize={{ width: 150, height: 70 }}
            />
          </li>
        ))}
      </ul>
    </PageContentBlock>
  );
};

Logos.defaultProps = {
  background: 'Low',
};

export default Logos;
